import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import RichTextEditor from './RichTextEditor';

const DetailedContentCard = ({ detailedContentHtml, setDetailedContentHtml }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E2E8F0',
        borderRadius: '8px',
        p: '14px 16px',
        mb: 1.75,
        boxShadow: 'none'
      }}
    >
      <Typography variant="subtitle1" sx={{ fontSize: 13.5, fontWeight: 600, color: '#1E293B', mb: 0.35, display: 'flex', alignItems: 'center' }}>
        Detailed Content{' '}
        <Box component="span" sx={{ backgroundColor: '#803927', color: '#fff', fontSize: 9.5, px: '5px', py: '1px', borderRadius: '4px', fontWeight: 600, ml: 0.75 }}>
          NEW
        </Box>
      </Typography>
      <Typography variant="body2" sx={{ color: '#64748B', fontSize: 11, mb: 1.25, lineHeight: 1.4 }}>
        About 500 words, shown below the retreat list. Use H2 headings. Links to other hub pages are encouraged.
      </Typography>

      <RichTextEditor
        value={detailedContentHtml}
        onChange={setDetailedContentHtml}
        minHeight={180}
      />
    </Paper>
  );
};

export default React.memo(DetailedContentCard);
